export const isRentalEnabled = (state) => state.Country.selectedCountry === 'germany';
